import * as Sentry from '@sentry/react';

export const initSentry = () => {
  let host = 'localhost';
  let environment = 'dev';
  if (import.meta.env.MODE !== 'development') {
    if (location.origin === 'https://staging-app.poupiu.com') {
      host = 'staging-app.poupiu.com';
      environment = 'test';
    } else {
      host = 'app.poupiu.com';
      environment = 'prod';
    }
  }
  console.log('init Sentry');
  Sentry.init({
    environment,
    dsn: 'https://2bb999aa2a117d137e3f4944510fc5cb@o4507684451123200.ingest.us.sentry.io/4510096403988480',
    debug: false,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        networkDetailAllowUrls: [window.location.origin, /.*/],
        networkCaptureBodies: true,
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],

    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [host, /^https:\/\/yourserver\.com\//],
    // Session Replay
    replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
  window.Sentry = Sentry;
};
